export const fullName = (fullname) => {
	return fullname != null ? fullname.match(/\b\w/g).join('').toUpperCase() : null;
};

export const getAddress = (data) => {
	let formattedAddress = '';
		formattedAddress = data.street_address && data.street_address + ', ';
		formattedAddress += data.city && data.city + ' , ';
		formattedAddress += data.state && data.state + ' , ';
		formattedAddress += data.country && data.country + ' , ';
		formattedAddress += data.zipcode && data.zipcode;
		formattedAddress = formattedAddress.trim(',');
		return formattedAddress;
};